module.exports = __webpack_public_path__ + "static/dartmouth-56648714a50fe723e76014affa9ab199.png";